import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "../../../components/Modal/Modal";
import Typography from "../../../components/Typography/Typography";
import Button from "../../../components/Button/Button";
import { Dropdown } from "../../../components/DropDown/DropDown";
import { useAppDispatch } from "../../../hooks";
import { getMyTimeOffAsync } from "../../../services/reducers/leaveReducer";
import UserImage from "../../../components/UserImage/UserImage";
import getInitialsInName from "../../../helper/GetNameInitials";
import { getDayAndMonth } from "../../../utils/common";
import EchopulseLoader from "../../loader/EchopulseLoader";

type Props = {
  onClose: () => void;
  leavebalance?: any;
  timeoffHistoryId?: string;
};
const SingleTimeOffHistoryModal: React.FC<Props> = ({
  onClose,
  leavebalance,
  timeoffHistoryId,
}) => {
  const [selectedValue, setSelectedValue] = useState<{
    label: string;
    value: string;
  }>({ label: "", value: timeoffHistoryId ?? "" });
  const dispatch = useAppDispatch();
  const [timeHistory, setTimeHistory] = useState<any>([]);
  const [timeDetail, setTimeDeatil] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  const handleDropdownChange = (selectedOption: any) => {
    setSelectedValue(selectedOption);
  };

  useEffect(() => {
    const selectedOption = leavebalance?.find(
      (option: any) => option.leaves.leaveId === timeoffHistoryId
    );
    if (selectedOption) {
      setSelectedValue({
        label: selectedOption.leaves.title,
        value: selectedOption.leaves.leaveId,
      });
    }
  }, []);

  useEffect(() => {
    getTimeoffList();
  }, [timeoffHistoryId, selectedValue]);

  const getTimeoffList = async () => {
    setLoading(true);
    const request: any = {
      SearchString: selectedValue.value,
    };
    await dispatch(getMyTimeOffAsync(request)).then((res) => {
      if (res.payload) {
        setTimeHistory(res.payload);
        setTimeDeatil(res.payload.flatMap((t: any) => t.details));
        setLoading(false);
      }
    });
  };

  const getMonthName = (monthNumber: number) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[monthNumber - 1];
  };

  return (
    <Modal isOpen onClose={onClose} placement="right" size="normal">
      <ModalHeader className="!px-12 bg-gray-200">
        <Typography className="font-bold" variant="h3">
          My Time Off History
        </Typography>
      </ModalHeader>
      {loading ? (
        <tr>
          <td colSpan={3}>
            <EchopulseLoader />
          </td>
        </tr>
      ) : (
        <>
          <ModalBody className="!px-12 !pt-10 !pb-5 bg-gray-400">
            <div className="flex justify-between items-center">
              <div className="flex justify-start items-center gap-2.5">
                <div>
                  {timeDetail[0]?.myProfile?.profilePic ? (
                    <UserImage
                      imgKey={timeDetail[0]?.myProfile?.profilePic}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                  ) : (
                    <img
                      src={getInitialsInName(
                        timeDetail[0]?.myProfile?.name ?? "N A",
                        24
                      )}
                      alt={timeDetail[0]?.myProfile?.name}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                  )}
                </div>
                <div>
                  <div className="text-600 text-gray-300 font-medium">
                    {timeDetail[0]?.myProfile?.name}
                  </div>
                  <div className="text-500 text-gray-300 font-normal">
                    {timeDetail[0]?.myProfile?.designation}
                    <span className="mx-1.5">|</span>
                    {timeDetail[0]?.myProfile?.team}
                  </div>
                </div>
              </div>

              <div className="w-[8.75rem]">
                <Dropdown
                  onChange={handleDropdownChange}
                  options={[
                    { label: "All", value: "" },
                    ...(leavebalance?.map((org: any) => ({
                      label: org.leaves.title,
                      value: org.leaves.leaveId,
                    })) || []),
                  ]}
                  type="smbox"
                  isSearchable={false}
                  value={selectedValue}
                />
              </div>
            </div>
            {timeHistory.map((t: any) => (
              <div className="mt-10">
                <div className="text-200 text-gray-300 font-nomal opacity-70 mb-3">
                  {t?.month !== 0 && (
                    <>
                      {getMonthName(t?.month)} {t?.year}
                    </>
                  )}
                </div>
                {t?.details &&
                  t?.details.map((item: any) =>
                    item?.leave === null ? (
                      <div className="flex justify-center items-center h-[calc(100vh-18.75rem)] text-center">
                        <div>
                          <div className="flex justify-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="111"
                              height="111"
                              viewBox="0 0 111 111"
                              fill="none"
                            >
                              <circle
                                cx="55.5"
                                cy="55.5"
                                r="55.5"
                                fill="white"
                              />
                              <path
                                d="M38.0438 25.9141H70.8976C81.4251 25.9141 84.0569 28.5459 84.0569 39.0438V57.7625C84.0569 68.2899 81.4251 70.8922 70.9272 70.8922H38.0438C27.5459 70.9218 24.9141 68.2899 24.9141 57.7921V39.0438C24.9141 28.5459 27.5459 25.9141 38.0438 25.9141Z"
                                fill="white"
                                stroke="#EFEFEF"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M64.109 37.6688V47.6931C64.109 50.7003 62.6054 52.7052 59.0969 52.7052H51.0775C47.5691 52.7052 46.0654 50.7003 46.0654 47.6931V37.6688C46.0654 34.6616 47.5691 32.6567 51.0775 32.6567H59.0969C62.6054 32.6567 64.109 34.6616 64.109 37.6688Z"
                                stroke="#EFEFEF"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M51.0776 37.6688H55.0873"
                                stroke="#EFEFEF"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M51.4785 42.6808H58.6959"
                                stroke="#EFEFEF"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M51.0776 47.6931H59.097"
                                stroke="#EFEFEF"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M54.4858 70.9221V85.0572"
                                stroke="#EFEFEF"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M24.9141 58.4431H84.0569"
                                stroke="#EFEFEF"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M41.1787 85.0574H67.793"
                                stroke="#EFEFEF"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <circle
                                cx="80.7144"
                                cy="31.3143"
                                r="9.53571"
                                fill="white"
                                stroke="#EFEFEF"
                                stroke-width="1.5"
                              />
                              <path
                                d="M85.2595 34.2337C84.9852 33.9616 84.6337 33.7807 84.2528 33.7157C83.8719 33.6507 83.4803 33.7048 83.1312 33.8706L81.6853 32.4309L83.7197 30.4027C83.8375 30.2849 83.9038 30.125 83.9038 29.9583C83.9038 29.7916 83.8375 29.6317 83.7197 29.5139C83.6018 29.396 83.4419 29.3298 83.2752 29.3298C83.1085 29.3298 82.9487 29.396 82.8308 29.5139L80.8026 31.5483L78.7745 29.5139C78.6566 29.396 78.4968 29.3298 78.3301 29.3298C78.1634 29.3298 78.0035 29.396 77.8856 29.5139C77.7678 29.6317 77.7015 29.7916 77.7015 29.9583C77.7015 30.125 77.7678 30.2849 77.8856 30.4027L79.92 32.4309L78.474 33.8769C78.1242 33.7173 77.7345 33.666 77.3553 33.7296C76.976 33.7932 76.6245 33.9687 76.3457 34.2337C76.1612 34.4056 76.0133 34.6129 75.9106 34.8433C75.808 35.0736 75.7528 35.3223 75.7483 35.5744C75.7439 35.8266 75.7903 36.077 75.8847 36.3109C75.9792 36.5447 76.1198 36.7571 76.2981 36.9355C76.4764 37.1138 76.6888 37.2544 76.9226 37.3488C77.1565 37.4433 77.4069 37.4896 77.6591 37.4852C77.9112 37.4807 78.1599 37.4255 78.3903 37.3229C78.6206 37.2203 78.8279 37.0723 78.9999 36.8878C79.3521 36.5359 79.5503 36.0586 79.5507 35.5607C79.549 35.2809 79.4849 35.005 79.3629 34.7532L80.8026 33.3135L82.2424 34.7532C82.1204 35.005 82.0562 35.2809 82.0546 35.5607C82.0543 35.8697 82.1303 36.1739 82.2757 36.4465C82.4212 36.719 82.6316 36.9515 82.8884 37.1233C83.1452 37.295 83.4404 37.4008 83.7478 37.4312C84.0553 37.4616 84.3655 37.4156 84.6509 37.2974C84.9363 37.1792 85.1882 36.9925 85.3842 36.7536C85.5802 36.5148 85.7142 36.2313 85.7744 35.9283C85.8346 35.6253 85.8191 35.3121 85.7293 35.0165C85.6395 34.7209 85.4781 34.452 85.2595 34.2337ZM78.1172 36.0052C78.059 36.0638 77.9898 36.1104 77.9135 36.1422C77.8373 36.174 77.7554 36.1903 77.6728 36.1903C77.5902 36.1903 77.5083 36.174 77.4321 36.1422C77.3558 36.1104 77.2866 36.0638 77.2284 36.0052C77.1413 35.9174 77.0822 35.8059 77.0585 35.6846C77.0347 35.5633 77.0474 35.4377 77.095 35.3236C77.1425 35.2095 77.2227 35.1121 77.3256 35.0435C77.4284 34.975 77.5492 34.9384 77.6728 34.9384C77.7964 34.9384 77.9172 34.975 78.02 35.0435C78.1229 35.1121 78.2031 35.2095 78.2506 35.3236C78.2982 35.4377 78.3108 35.5633 78.2871 35.6846C78.2634 35.8059 78.2043 35.9174 78.1172 36.0052ZM84.3769 36.0052C84.3187 36.0638 84.2495 36.1104 84.1732 36.1422C84.0969 36.174 84.0151 36.1903 83.9325 36.1903C83.8499 36.1903 83.768 36.174 83.6918 36.1422C83.6155 36.1104 83.5462 36.0638 83.4881 36.0052C83.4294 35.947 83.3828 35.8777 83.351 35.8015C83.3193 35.7252 83.3029 35.6434 83.3029 35.5607C83.3029 35.4781 83.3193 35.3963 83.351 35.32C83.3828 35.2437 83.4294 35.1745 83.4881 35.1163C83.5462 35.0576 83.6155 35.011 83.6918 34.9793C83.768 34.9475 83.8499 34.9311 83.9325 34.9311C84.0151 34.9311 84.0969 34.9475 84.1732 34.9793C84.2495 35.011 84.3187 35.0576 84.3769 35.1163C84.4356 35.1745 84.4822 35.2437 84.5139 35.32C84.5457 35.3963 84.5621 35.4781 84.5621 35.5607C84.5621 35.6434 84.5457 35.7252 84.5139 35.8015C84.4822 35.8777 84.4356 35.947 84.3769 36.0052Z"
                                fill="#EFEFEF"
                              />
                              <path
                                d="M86.4364 26.1714H75.1689C75.0029 26.1714 74.8437 26.2374 74.7263 26.3548C74.6089 26.4722 74.543 26.6314 74.543 26.7974V33.0571C74.543 33.2231 74.6089 33.3823 74.7263 33.4997C74.8437 33.6171 75.0029 33.6831 75.1689 33.6831C75.335 33.6831 75.4942 33.6171 75.6116 33.4997C75.729 33.3823 75.7949 33.2231 75.7949 33.0571V27.4234H85.8104V33.0571C85.8104 33.2231 85.8764 33.3823 85.9938 33.4997C86.1111 33.6171 86.2704 33.6831 86.4364 33.6831C86.6024 33.6831 86.7616 33.6171 86.879 33.4997C86.9964 33.3823 87.0623 33.2231 87.0623 33.0571V26.7974C87.0623 26.6314 86.9964 26.4722 86.879 26.3548C86.7616 26.2374 86.6024 26.1714 86.4364 26.1714Z"
                                fill="#EFEFEF"
                              />
                            </svg>
                          </div>
                          <div className="text-gray-700 text-400 font-normal mt-1.5">
                            Your time off history will be<br></br> represented
                            here.
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="">
                        <div className="flex justify-start items-center py-3 border-b border-black border-opacity-10">
                          <div className="w-[8.125rem]">
                            <div className="text-200 text-gray-300 font-semibold">
                              {getDayAndMonth(item?.startDate).month}{" "}
                              {getDayAndMonth(item?.startDate).day} -{" "}
                              {getDayAndMonth(item?.endDate).month}{" "}
                              {getDayAndMonth(item?.endDate).day}
                            </div>
                          </div>
                          <div className="w-[6.688rem]">
                            <div className="text-200 text-gray-300 font-semibold">
                              {item?.requestFor}{" "}
                              <span className="font-normal">
                                {" "}
                                {item?.requestFor !== null &&
                                item?.requestFor > 1
                                  ? "Days"
                                  : "Day"}
                              </span>
                            </div>
                          </div>
                          <div className="w-[7rem]">
                            <div className="text-200 text-gray-300 font-normal opacity-70">
                              {item?.leave?.title}
                            </div>
                          </div>

                          {item?.isLeaveCancelled === true ? (
                            <div className="w-[calc(100%-20.938rem)] flex justify-end items-center">
                              <div className="flex justify-start items-center text-[0.5rem] uppercase font-normal text-secondary-300 py-1 px-2.5 rounded-full bg-pastel-600">
                                <span className="me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <path
                                      d="M8 0.5C3.8579 0.5 0.5 3.8579 0.5 8C0.5 12.1421 3.8579 15.5 8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.8579 12.1421 0.5 8 0.5ZM11.7961 10.2107C12.2339 10.6485 12.2339 11.3584 11.7961 11.7961C11.3582 12.2339 10.6484 12.2339 10.2107 11.7961L8 9.58539L5.7893 11.7961C5.35145 12.2339 4.64158 12.2339 4.20391 11.7961C3.76607 11.3582 3.76607 10.6484 4.20391 10.2107L6.41461 8L4.20391 5.7893C3.76607 5.35145 3.76607 4.64158 4.20391 4.20391C4.64175 3.76607 5.35163 3.76607 5.7893 4.20391L8 6.41461L10.2107 4.20391C10.6485 3.76607 11.3584 3.76607 11.7961 4.20391C12.2339 4.64175 12.2339 5.35163 11.7961 5.7893L9.58539 8L11.7961 10.2107Z"
                                      fill="#ECB22E"
                                    />
                                  </svg>
                                </span>
                                Cancelled
                              </div>
                            </div>
                          ) : (
                            item?.isApproved === true && (
                              <div className="w-[calc(100%-20.938rem)] flex justify-end items-center">
                                <div className="flex justify-start items-center text-[0.5rem] uppercase font-normal text-green-100 py-1 px-2.5 rounded-full bg-green-100 bg-opacity-10">
                                  <span className="me-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="17"
                                      height="17"
                                      viewBox="0 0 17 17"
                                      fill="none"
                                    >
                                      <path
                                        d="M8.50952 16.512C12.9095 16.512 16.5095 12.912 16.5095 8.51196C16.5095 4.11196 12.9095 0.511963 8.50952 0.511963C4.10952 0.511963 0.509521 4.11196 0.509521 8.51196C0.509521 12.912 4.10952 16.512 8.50952 16.512Z"
                                        fill="#2EB67D"
                                      />
                                      <path
                                        d="M5.10986 8.51205L7.37386 10.776L11.9099 6.24805"
                                        fill="#2EB67D"
                                      />
                                      <path
                                        d="M5.10986 8.51205L7.37386 10.776L11.9099 6.24805"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </span>
                                  Approved
                                </div>
                              </div>
                            )
                          )}
                          {item?.isApproved === null && (
                            <div className="w-[calc(100%-20.938rem)] flex justify-end items-center">
                              <div className="flex justify-start items-center text-[0.5rem] uppercase font-normal text-gray-700 py-1 px-2.5 rounded-full bg-gray-100">
                                <span className="me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="16"
                                    viewBox="0 0 17 16"
                                    fill="none"
                                  >
                                    <path
                                      d="M16.4949 13.8477C16.4742 13.6151 16.3932 13.3733 16.2516 13.1286L9.64024 1.67721C9.49942 1.43254 9.33087 1.24124 9.13955 1.10681C8.94183 0.968837 8.72063 0.896301 8.50016 0.896301C8.27969 0.896301 8.05849 0.968846 7.86078 1.10681C7.66946 1.24052 7.5009 1.43256 7.36009 1.67721L0.747964 13.1286C0.607143 13.3733 0.525345 13.6151 0.504735 13.8477C0.48411 14.0873 0.53105 14.3156 0.642001 14.507C0.75224 14.6983 0.925778 14.8533 1.14412 14.955C1.35536 15.0539 1.60571 15.1037 1.88805 15.1037H15.111C15.3934 15.1037 15.6437 15.0539 15.8549 14.955C16.0733 14.8533 16.2468 14.6983 16.3571 14.507C16.4687 14.3156 16.5162 14.0873 16.4949 13.8477ZM8.50009 13.0404C8.05558 13.0404 7.69499 12.6798 7.69499 12.2353C7.69499 11.7908 8.05558 11.4309 8.50009 11.4309C8.9446 11.4309 9.30519 11.7908 9.30519 12.2353C9.30519 12.6798 8.9446 13.0404 8.50009 13.0404ZM9.46735 5.8728L9.20917 10.1358C9.19423 10.3919 8.97091 10.6017 8.71415 10.6017H8.28457C8.02781 10.6017 7.80521 10.3919 7.78956 10.1358L7.53138 5.8728C7.51573 5.61677 7.71274 5.40695 7.96948 5.40695H9.02706C9.28524 5.40766 9.48299 5.61675 9.46735 5.8728Z"
                                      fill="#888888"
                                    />
                                  </svg>
                                </span>
                                PENDING
                              </div>
                            </div>
                          )}
                          {item?.isApproved === false && (
                            <div className="w-[calc(100%-20.938rem)] flex justify-end items-center">
                              <div className="flex justify-start items-center text-[0.5rem] uppercase font-normal text-primary-100 py-1 px-2.5 rounded-full bg-primary-100 bg-opacity-10">
                                <span className="me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="16"
                                    viewBox="0 0 14 16"
                                    fill="none"
                                  >
                                    <path
                                      d="M7 0.5C10.866 0.5 14 3.8579 14 8C14 12.1421 10.866 15.5 7 15.5C3.13404 15.5 0 12.1421 0 8C0 3.8579 3.13404 0.5 7 0.5ZM3.45698 10.2107C3.04833 10.6485 3.04833 11.3584 3.45698 11.7961C3.86564 12.2339 4.52819 12.2339 4.93668 11.7961L7 9.58539L9.06332 11.7961C9.47198 12.2339 10.1345 12.2339 10.543 11.7961C10.9517 11.3582 10.9517 10.6484 10.543 10.2107L8.47969 8L10.543 5.7893C10.9517 5.35145 10.9517 4.64158 10.543 4.20391C10.1344 3.76607 9.47182 3.76607 9.06332 4.20391L7 6.41461L4.93668 4.20391C4.52802 3.76607 3.86548 3.76607 3.45698 4.20391C3.04833 4.64175 3.04833 5.35163 3.45698 5.7893L5.52031 8L3.45698 10.2107Z"
                                      fill="#F15845"
                                    />
                                  </svg>
                                </span>
                                DENIED
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  )}
              </div>
            ))}
          </ModalBody>

          <ModalFooter className="!px-12">
            <Button
              label="Okay"
              variant="primary"
              size="large"
              onClick={onClose}
            />
          </ModalFooter>
        </>
      )}
    </Modal>
  );
};

export default SingleTimeOffHistoryModal;
